export default __webpack_public_path__ + "static/media/finishedLabel.8fdf2e5d.svg";